export enum EClassifications {
    MAKE = 'MAKE',
    MODEL = 'MODEL',
    SAFE_TYPE = 'SAFE-TYPE',
    SAFE_SUB_TYPE = 'SAFE-SUB-TYPE',
    CONTACT_CATEGORY = 'CONTACT-CATEGORY',
    CONTACT_TOPIC = 'CONTACT-TOPIC',
    ISSUE = 'ISSUE',
    SAFE_MAKE = 'SAFE-MAKE',
    SAFE_MODEL = 'SAFE-MODEL',
    STORAGE_TYPE = 'STORAGE-TYPE',
    COMPONENT = 'COMPONENT',
}
